module.exports = __webpack_public_path__ + "images/store_case_study/liquorjoy-pic1_61fa8a3430a8f3bee8e0d155a5875170.png";